import cx from 'classnames'
import * as React from 'react'

import type { OptionLinkViewModel } from '../../view-models/OptionLinkViewModel'
import OptionLink from './OptionLink/OptionLink'
import styles from './optionLinks-style.css'

type Props = {
  items: OptionLinkViewModel[]
  //@ internal
  className?: string
}
type State = {}

class OptionLinks extends React.Component<Props, State> {
  static displayName = 'OptionLinks'
  static defaultProps = {}

  render() {
    const { items, className } = this.props
    if (!items) return null

    return (
      <ul className={cx(styles.optionLinks, className)}>
        {items.map((item) => (
          <OptionLink
            key={item.title}
            {...item}
            eventMeta={{
              event: 'modules-interaction',
              eventData: 'muligheder',
            }}
          />
        ))}
      </ul>
    )
  }
}

export default OptionLinks